import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { Clock, MapPin, Mail, Phone, Menu, X, ChevronLeft, ChevronRight, Activity, Heart, Droplets } from 'lucide-react';
export default function WellnessSite() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Hero carousel images - REPLACE THESE WITH YOUR OWN IMAGES
  const heroImages = [
    {
      url: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&h=600&fit=crop',
      title: 'Professional Massage Therapy',
      subtitle: 'Expert care in the comfort of your home'
    },
    {
      url: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1200&h=600&fit=crop',
      title: 'Mobile Massage Service',
      subtitle: 'Bringing relaxation and wellness to you'
    },
    {
      url: 'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&h=600&fit=crop',
      title: 'Your Wellness Journey',
      subtitle: 'Personalized treatments tailored to your needs'
    }
  ];

  // Gallery images - REPLACE THESE WITH YOUR OWN IMAGES
  const galleryImages = [
    'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&h=300&fit=crop'
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header/Navigation */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
          <Navigation />        
     </header>

      {/* Hero Carousel Section */}
      <section id="home" className="relative h-screen max-h-screen overflow-hidden">
        {/* Carousel Images */}
        <div className="relative h-full">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image.url} 
                alt={image.title}
                className="w-full h-full object-cover"
              />
              {/* Dark overlay for text readability */}
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              
              {/* Text overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center text-white px-4">
                  <h1 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow-lg">
                    {image.title}
                  </h1>
                  <p className="text-xl md:text-2xl text-gray-100 mb-8 drop-shadow-md">
                    {image.subtitle}
                  </p>
                  <Link 
      to="/book" 
      className="inline-block bg-brand text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-teal-700 transition shadow-lg"
    >
      Book Now
    </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Previous Button */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-75 text-gray-800 p-3 rounded-full transition z-10"
        >
          <ChevronLeft size={24} />
        </button>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-75 text-gray-800 p-3 rounded-full transition z-10"
        >
          <ChevronRight size={24} />
        </button>

        {/* Dots Navigation */}
        <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-3 z-10">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlide 
                  ? 'bg-white w-8' 
                  : 'bg-white bg-opacity-50 hover:bg-opacity-75'
              }`}
            />
          ))}
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Welcome to Hollis Massage
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            I'm a fully qualified massage therapist bringing professional treatments directly to your home or workplace in and around Rugby and Warwickshire. 
            I offer personalised massage therapy tailored to your individual needs.
          </p>
          <p className="text-lg text-gray-600">
            Whether you're seeking relief from muscle tension, stress reduction, or simply want to relax and unwind, 
            I provide a mobile service that brings the spa experience to you.
          </p>
        </div>
      </section>

     {/* Services Section */}
    <section id="services" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          My Services
        </h2>
        <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
          Professional massage therapy in outskirts of Rugby, with mobile service available
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
            <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
              <Activity className="text-white" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Deep Tissue Massage</h3>
            <p className="text-gray-600">
              Focused pressure to release muscle tension and knots. Great for persistent aches, pains, and tight muscles.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
            <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
              <Heart className="text-white" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Swedish Massage</h3>
            <p className="text-gray-600">
              Classic relaxation massage using flowing strokes to ease tension, improve circulation, and promote overall wellbeing.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition">
            <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mb-4">
              <Droplets className="text-white" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Traditional Lymphatic Drainage</h3>
            <p className="text-gray-600 mb-3">
              Very gentle, rhythmic wave-like strokes following the lymphatic system pathways.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition border-2 border-teal-200">
            <div className="flex justify-between items-start mb-4">
              <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center">
                <Droplets className="text-white" size={32} />
              </div>
              <span className="bg-teal-100 text-teal-800 text-xs font-semibold px-3 py-1 rounded-full">
                Available from 1st Dec
              </span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Brazilian Lymphatic Drainage</h3>
            <p className="text-gray-600 mb-3">
              Dynamic contouring technique combining lymphatic drainage with firmer pressure and fast-paced movements.
            </p>            
          </div>
        </div>

        {/* Lymphatic Drainage Comparison */}
        <div className="mt-16 bg-teal-50 border-2 border-teal-200 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Lymphatic Drainage: Traditional vs Brazilian
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-bold text-teal-900 mb-3 flex items-center">
                <Droplets className="mr-2" size={20} />
                Traditional Manual Lymphatic Drainage
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Technique:</strong> Gentle, rhythmic, wave-like strokes following lymphatic pathways</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Pressure:</strong> Very light and slow; skin barely moves</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Purpose:</strong> Therapeutic treatment for medical conditions</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Effect:</strong> Encourages lymph flow and detoxification.  Boots the immune system and can facilitate general feeling of health and vitality.</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-teal-900 mb-3 flex items-center">
                <Droplets className="mr-2" size={20} />
                Brazilian Lymphatic Drainage <span className="ml-2 text-xs bg-teal-100 text-teal-800 px-2 py-1 rounded">New!</span>
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Technique:</strong> Vigorous contouring with deeper pressure and dynamic movements</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Pressure:</strong> Medium to firm with fast-paced strokes</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Purpose:</strong> Functional and aesthetic body contouring</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-600 mr-2">•</span>
                  <span><strong>Effect:</strong> Reduces puffiness, defines contours, improves skin tone</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Gallery Section 
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            Treatment Gallery
          </h2>
          <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
            A glimpse of the professional, relaxing experience I provide
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition group cursor-pointer"
              >
                <img 
                  src={image} 
                  alt={`Treatment ${index + 1}`}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-teal-600 bg-opacity-0 group-hover:bg-opacity-20 transition"></div>
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      {/* Feature Image Section */}
<section className="py-20 bg-white">
  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="rounded-2xl overflow-hidden shadow-xl">
      <img 
        src="https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&h=600&fit=crop" 
        alt="Professional Massage Treatment"
        className="w-full h-64 md:h-96 object-cover"
      />
    </div>
    <p className="text-center text-gray-600 mt-6 max-w-2xl mx-auto">
      Professional, relaxing treatments in a comfortable environment
    </p>
  </div>
</section>

      {/* Contact Info Section */}
      <section id="contact" className="py-20 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
            Get In Touch
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Location */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <MapPin className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Service Area</h3>
              <p className="text-gray-700 text-center mb-2 font-semibold">Rugby & Surrounding Areas</p>
              <p className="text-gray-600 text-center">Massage in home location or mobile service on request</p>
              <p className="text-gray-600 text-center mt-4 text-sm">Based in outskirts of Rugby</p>
            </div>
            {/* Hours */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <Clock className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Availability</h3>
              <div className="space-y-2 text-center">
                <p className="text-gray-700"><span className="font-semibold">Monday-Thursday:</span> 5.30pm - 7.30pm</p>
                <p className="text-gray-700"><span className="font-semibold">Friday:</span> 3pm - 7pm</p>
                <p className="text-gray-700"><span className="font-semibold">Saturday-Sunday:</span> Appointments can be provided on request</p>
              </div>
              <p className="text-sm text-gray-500 text-center mt-4">
                Other times available on request
              </p>
            </div>

            {/* Contact */}
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6 mx-auto">
                <Mail className="text-white" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Contact Me</h3>
              <div className="space-y-4">
                <a 
                  href="mailto:hollismassage@hotmail.com" 
                  className="flex items-center justify-center text-teal-600 hover:text-teal-700 transition"
                >
                  <Mail size={20} className="mr-2" />
                  hollismassage@hotmail.com
                </a>
                {/*<a 
                  href="tel:+447710 469 484" 
                  className="flex items-center justify-center text-teal-600 hover:text-teal-700 transition"
                >
                  <Phone size={20} className="mr-2" />
                  07710 469 484
                </a>*/}
                <button className="w-full mt-4 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition shadow-md">
                  Book Your Session
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400">
            Hollis Massage © {new Date().getFullYear()}
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Massage Therapy - Rugby
          </p>
        </div>
      </footer>
    </div>
  );
}